type AccordionItemLike = {
	_key: string;
	defaultOpen?: boolean | null;
};

export function getDefaultOpenKey(items: AccordionItemLike[]): string {
	const defaultItem = items.find((item) => item.defaultOpen);
	return defaultItem?._key ?? items[0]?._key ?? "";
}

/**
 * Item that should appear open. Desktop (≥1024px) always shows one item so the
 * side media panel is never empty. Below desktop, all items may be collapsed.
 */
export function resolveOpenAccordionKey(
	opened: string | null,
	isDesktop: boolean,
	defaultKey: string
): string | null {
	if (opened) {
		return opened;
	}
	if (isDesktop) {
		return defaultKey || null;
	}
	return null;
}

/**
 * Desktop ignores a collapse (`null`) so one item stays open. Below desktop,
 * `null` is accepted and every section can close.
 */
export function shouldAcceptAccordionChange(
	value: string | null,
	isDesktop: boolean
): boolean {
	return value != null || !isDesktop;
}
